
<mat-card class="full-stretch responsive-card">
  <mat-card-header #cardHeader class="padding-standard card-header border-primary-bottom">
    
    <mat-card-title class="mat-headline-4 margin-none">{{data.formOptions.title | translate}}</mat-card-title>
    <mat-card-subtitle>{{data.formOptions.subtitle | translate}}</mat-card-subtitle>
    <button mat-icon-button mat-dialog-close (click)="cancel()"><mat-icon>close</mat-icon></button>

  </mat-card-header>

  <mat-card-content 
    fixedScroll 
    [otherElements]="[header,footer]" 
    class="padding-standard-inline padding-large-block flex-column ">

    <ss-dynamic-form  [controls]="data.formOptions.controls"
                      [showClearBtn]="data.formOptions.showClearBtn"
                      [defaultBtnText]="data.formOptions.defaultBtnText"
                      (formSubmit)="submit($event)"
                      [submitButton]="submitButton._elementRef.nativeElement"
    >

 
    </ss-dynamic-form>

  </mat-card-content>

  <mat-card-footer #footer>

    <mat-card-actions class="responsive-actions padding-standard gap-small">
      <button class="flex-1" (click)="cancel()" type="button" mat-raised-button color="warn">
        {{ "ss-general.cancel" | translate }}
      </button>

      <button class="flex-1"  #submitButton type="submit" mat-raised-button color="primary">
        {{ (data.formOptions.defaultBtnText || "ss-general.next") | translate }}
      </button>  
    </mat-card-actions>

  </mat-card-footer>
</mat-card>